export default "__VITE_ASSET__DzHqQNbO__"